import React from "react";
import { SvgIcon } from "@material-ui/core";

const CuentaCorriente = props => (
  <SvgIcon viewBox="0 0 226.77 141.73" {...props}>
    <g transform="translate(3.346 3.991)">
    <path fill="rgba(112,112,112,0.35)" d="M197.584,84.438h-14.201v-29.19c0-4.142-3.358-7.5-7.5-7.5h-9.339v-17.49c0-4.142-3.358-7.5-7.5-7.5H24.339
		c-4.142,0-7.5,3.358-7.5,7.5v17.49H7.5c-4.142,0-7.5,3.358-7.5,7.5v119.576c0,4.142,3.358,7.5,7.5,7.5h168.383
		c4.142,0,7.5-3.358,7.5-7.5v-28.848h14.201c4.142,0,7.5-3.358,7.5-7.5V91.938C205.084,87.796,201.726,84.438,197.584,84.438z
		 M31.839,37.759h119.705v9.99H31.839V37.759z M168.383,167.325H15V62.749h153.383v21.69h-36.334c-4.142,0-7.5,3.358-7.5,7.5v46.539
		c0,4.142,3.358,7.5,7.5,7.5h36.334V167.325z M190.084,130.977h-50.535V99.438h50.535V130.977z"/>
    <circle fill="rgba(112,112,112,0.35)" cx="164.816" cy="115.208" r="11.635" />
    </g>
  </SvgIcon>
);

export default CuentaCorriente;
